import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Modal, TextArea } from "semantic-ui-react";
import agent from "../../../app/api/agent";
import useToaster from "../../../app/hooks/useToaster";

interface IProps {
  applicationId: number | null;
  onClose(): void;
  onReturned(applicationId: number): void;
}

// School asks the student to fix the application; the student sees the comment and can resubmit.
const ReturnForEditModal = ({ applicationId, onClose, onReturned }: IProps) => {
  const { t } = useTranslation();
  const { apiError } = useToaster();
  const [reason, setReason] = useState("");
  const [isReturning, setIsReturning] = useState(false);

  const close = () => {
    setReason("");
    onClose();
  };

  const handleConfirm = () => {
    if (applicationId === null || !reason.trim()) return;
    setIsReturning(true);
    agent.Applications.returnForEdit(applicationId, reason.trim())
      .then(() => {
        setReason("");
        onReturned(applicationId);
      })
      .catch(apiError)
      .finally(() => setIsReturning(false));
  };

  return (
    <Modal size="small" open={applicationId !== null} onClose={close}>
      <Modal.Header>{t("applications.school.actions.return_for_edit")}</Modal.Header>
      <Modal.Content>
        <p>{t("applications.school.return_reason_label")}</p>
        <Form>
          <TextArea
            rows={4}
            value={reason}
            onChange={(_, { value }) => setReason(value as string)}
            placeholder={t("applications.school.return_reason_placeholder")}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>{t("common.actions.cancel")}</Button>
        <Button color="orange" disabled={!reason.trim() || isReturning} loading={isReturning} onClick={handleConfirm}>
          {t("applications.school.actions.return_confirm")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ReturnForEditModal;
